import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../contexts/LanguageContext";

const MarqueeStrip = () => {
  const { lang } = useLang();

  const items = {
    en: [
      "Sunflower oil",
      "Refined & crude",
      "Private label",
      "Export-grade",
      "Since 2003",
      "Kherson · Ukraine",
      "Non-GMO",
      "ISO 22000",
      "HACCP certified",
      "Flexitank ready",
    ],
    fr: [
      "Huile de tournesol",
      "Raffinée & brute",
      "Marque privée",
      "Qualité export",
      "Depuis 2003",
      "Kherson · Ukraine",
      "Non-OGM",
      "ISO 22000",
      "Certifié HACCP",
      "Flexitank prêt",
    ],
    ua: [
      "Соняшникова олія",
      "Рафінована та сира",
      "Приватна марка",
      "Експортна якість",
      "З 2003 року",
      "Херсон · Україна",
      "Non-GMO",
      "ISO 22000",
      "HACCP сертифіковано",
      "Флекситанк готовий",
    ],
  };
  const list = items[lang] || items.en;

  return (
    <section
      data-testid="marquee-strip"
      className="relative bg-[#DE9E36] text-[#1A201C] py-4 overflow-hidden border-y border-[#1A201C]/10"
    >
      <Marquee gradient={false} speed={55} pauseOnHover>
        {[...list, ...list].map((item, i) => (
          <span
            key={i}
            className="mx-6 inline-flex items-center gap-6 text-base md:text-lg font-semibold tracking-wide uppercase"
          >
            {item}
            <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
              <circle cx="5" cy="5" r="2.5" fill="#1A201C" />
            </svg>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default MarqueeStrip;
